import { render, staticRenderFns } from "./sos_dispatch.vue?vue&type=template&id=2a36a7c8&scoped=true&"
import script from "./sos_dispatch.vue?vue&type=script&lang=js&"
export * from "./sos_dispatch.vue?vue&type=script&lang=js&"
import style0 from "./sos_dispatch.vue?vue&type=style&index=0&id=2a36a7c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a36a7c8",
  null
  
)

export default component.exports